import { createPortal } from "react-dom";
import { ExternalLinkConfirmation, BlockedLinkAlert } from "../";

type AlertType = "confirmation" | "blocked";

interface LinkSecurityAlertProps {
  alertType: AlertType | null;
  alertPosition: { top: number; left: number };
  onConfirmationCancel: () => void;
  onConfirmationContinue: () => void;
  onBlockedDismiss: () => void;
  topOffset?: number;
  useAbsolutePositioning?: boolean; // Use absolute positioning instead of fixed (for sidebar)
}

export function LinkSecurityAlert({
  alertType,
  alertPosition,
  onConfirmationCancel,
  onConfirmationContinue,
  onBlockedDismiss,
  useAbsolutePositioning = false, // Default to fixed positioning
}: LinkSecurityAlertProps) {
  if (!alertType) {
    return null;
  }

  const alertContent = (
    <div
      style={{
        position: useAbsolutePositioning ? "absolute" : "fixed",
        top: alertPosition.top,
        left: alertPosition.left,
      }}
    >
      {alertType === "confirmation" && (
        <ExternalLinkConfirmation
          onCancel={onConfirmationCancel}
          onContinue={onConfirmationContinue}
        />
      )}

      {alertType === "blocked" && (
        <BlockedLinkAlert onDismiss={onBlockedDismiss} />
      )}
    </div>
  );

  // Use portal for fixed positioning (canvas), direct render for absolute positioning (sidebar)
  return useAbsolutePositioning
    ? alertContent
    : createPortal(alertContent, document.body);
}
